import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { faChevronDown, faSquareXmark } from '@fortawesome/free-solid-svg-icons';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { CargoPessoaExposta } from 'src/app/shared/enum/cargo-pessoa-exposta';
import { PersonStatementType } from 'src/app/shared/enum/person-statement';
import { PersonStatementItem } from 'src/app/shared/models/previdencia/person-statement-item';
import { StatementPPE } from 'src/app/shared/models/previdencia/statement-ppe';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
import { FormValidator } from 'src/app/shared/validators/Validator';
import Swal from 'sweetalert2';
import { DeclaracaoService } from '../../../services/saude/declaracao.service';
@Component({ selector: 'app-p-p-e', templateUrl: './p-p-e.component.html', styleUrls: ['./p-p-e.component.css'] })
export class PPEComponent {
  //Icones
  faSquareXmark = faSquareXmark;
  faChevronDown = faChevronDown;
  redirecionado: boolean = true;
  cargo = CargoPessoaExposta;
  statmentType = PersonStatementType;
  selectedOption!: boolean;
  todaysDate: any = new Date().toJSON().split('T')[0];
  formDataEdit: boolean = false;
  beneficiaries!: any[];
  positions!: any[];
  politicallyExposedList: any[] = [{ desc: "SIM", value: true }, { desc: "NÃO", value: false }];
  listaPerson: any[] = [];
  listaFamily: any[] = [];
  listRelationships: any[] = [];
  historicoDeclaracao: any;
  personCpf: number = 0;
  personStatement!: StatementPPE;
  personItems!: PersonStatementItem[];
  familyItems!: PersonStatementItem[];
  relationshipsItems!: PersonStatementItem[];
  mostrarDeclaracoes: boolean = true;
  loading: boolean = false;
  formData: FormGroup = this.formBuilder.group({
    acceptedterms: new FormControl(false, [Validators.required]),
    personCpf: new FormControl(null, [Validators.required]),
    politicallyExposed: new FormControl(null, [Validators.required]),
    items: new FormControl(null, [Validators.required]),
  });
  constructor(
    @Inject(FormBuilder) private formBuilder: FormBuilder, private formValidator: FormValidator, private userService: UsuarioService, private statementPPEService: DeclaracaoService,
    private toast: ToastrService, private bsLocaleService: BsLocaleService, private router: Router, private route: ActivatedRoute) {
    this.userService.getBeneficiaries().subscribe((res: any) => { this.formData.get('personCpf')?.setValue(res[0].id); });
    //Alterando a data do calendário para pt-br
    this.bsLocaleService.use('pt-br');
    //cargos
    this.statementPPEService.getPositions().subscribe((res: any) => { this.positions = res; });
    this.verificarUltimasDeclaracoes();
  }
  verificarUltimasDeclaracoes() {
    this.statementPPEService.getLastStatement().subscribe({
      next: (res: any) => {
        this.personStatement = res;
        this.mostrarDeclaracoes = true;
        this.inicializarDeclaracoes(res.exposedPersonStatementItem);
      }
    });
  }
  removePerson(value: any, position: number) {
    switch (value) {
      case 1:
        this.listaPerson.splice(position, 1);
        this.toast.success('Pessoa removida com Sucesso!');
        break;
      case 2:
        this.listaFamily.splice(position, 1);
        this.toast.success('Pessoa removida com Sucesso!');
        break;
      case 3:
        this.listRelationships.splice(position, 1);
        this.toast.success('Pessoa removida com Sucesso!');
        break;
    }
  }
  limparSelecao() {
    this.verificarUltimasDeclaracoes();
  }
  opcaoSelecionada() {
    this.formData.get('politicallyExposed')?.setValue(this.selectedOption);
  }
  criarContatoFormGroup() {
    return this.formBuilder.group({
      dataEntrada: '',
      dataSaida: '',
      nome: '',
    });
  }
  inicializarDeclaracoes(event: any) {
    event.forEach((element: any) => {
      switch (element.exposedPersonStatementTypeId) {
        case 1:
          this.listaPerson.push({ name: element.name, initialDate: element.initialDate, finalDate: element.finalDate, exposedPersonPositionId: element.positionId, exposedPersonStatementTypeId: element.exposedPersonStatementTypeId });
          break;
        case 2:
          this.listaFamily.push({ name: element.name, initialDate: element.initialDate, finalDate: element.finalDate, exposedPersonPositionId: element.positionId, exposedPersonStatementTypeId: element.exposedPersonStatementTypeId });
          break;
        case 3:
          this.listRelationships.push({ name: element.name, initialDate: element.initialDate, finalDate: element.finalDate, exposedPersonPositionId: element.positionId, exposedPersonStatementTypeId: element.exposedPersonStatementTypeId });
          break;
      }
    });
  }
  adicionarPolitico(event: any) {
    this.verificaDeclaracaoList(event);
    switch (event.exposedPersonStatementTypeId) {
      case 1:
        (this.verificaDeclaracaoList(event)) ? this.toast.success('Mensagem de sucesso', 'Título') : this.listaPerson.push(event);
        break;
      case 2:
        (this.verificaDeclaracaoList(event)) ? this.toast.error('Existe uma pessoa declarada com o nome informado!') : this.listaFamily.push(event);
        break;
      case 3:
        (this.verificaDeclaracaoList(event)) ? this.toast.error('Existe uma pessoa declarada com o nome informado!') : this.listRelationships.push(event);
        break;
    }
  }
  verificaDeclaracaoList(item: any): boolean {
    if (this.listaPerson.find((a: any) => a.name.toUpperCase() === item.name.toUpperCase())) {
      return true;
    } else if (this.listaFamily.find((a: any) => a.name.toUpperCase() === item.name.toUpperCase())) {
      return true;
    } else if (this.listRelationships.find((a: any) => a.name.toUpperCase() === item.name.toUpperCase())) {
      return true;
    } else {
      return false;
    }
  }
  bloquearCampos() {
    this.verificarUltimasDeclaracoes();
    this.formData.get('politicallyExposed')?.setValue(null);
    this.mostrarDeclaracoes = true;
  }
  fecharNgSelect() { }
  novaDeclaracao() {
    Swal.fire({
      title: 'Deseja replicar os dados da última declaração?',
      icon: 'question',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonColor: '#1A428A',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' }
    }).then(
      (result: any) => {
        if (!result.isConfirmed) {
          this.listaPerson.splice(0, this.listaPerson.length);
          this.listaFamily.splice(0, this.listaFamily.length);
          this.listRelationships.splice(0, this.listRelationships.length);
          this.mostrarDeclaracoes = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          this.formData.get('politicallyExposed')?.setValue(true);
          this.mostrarDeclaracoes = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
  }
  redirect() {
    this.router.navigate(['historico'], { relativeTo: this.route });
  }
  saveStatement() {
    this.formData.get('items')?.setValue([...this.listaPerson, ...this.listaFamily, ...this.listRelationships]);
    this.statementPPEService.postStatement(this.formData.value).subscribe({
      next: (res: any) => {
        Swal.fire({
          title: 'Declaração realizada com sucesso!',
          text: 'Para verificar suas declarações, basta acessar Históricos de Declarações no botão abaixo, caso queira voltar para tela de cadastro clique em OK.',
          icon: 'success',
          showConfirmButton: false,
        }).then((result: any) => { });
      },
      error: (erro: any) => {
      }
    });
  }
  addOrRemoveCollapse(lista: any[], nome: string) {
    lista.forEach((item: any) => {
      if (item.name === nome) {
        const element = document.getElementById('collapse_' + nome);
        if (element?.classList.contains('show')) {
          element.classList.remove('show');
        } else {
          element?.classList.add('show');
        }
      }
    });
  }
  goFCopel() {
    (window as any).open("http://www.previc.gov.br/regulacao/normas/instrucoes/instrucoes-previc/2014/instrucao-previc-no-18-de-24-de-dezembro-de-2014.pdf/view", "_blank");
  }
  private getStatemant(idStatement: number): FormGroup {
    return this.formBuilder.group({
      name: [null, Validators.required],
      job: [null, Validators.required],
      exposedPersonPositionId: [null, Validators.required],
      initialDate: [null, [Validators.required, this.formValidator.isValidDateToday]],
      finalDate: [null, this.formValidator.isValidDateToday],
      exposedPersonStatementTypeId: [idStatement]
    });
  }
}
